/* === Arquivo: src/components/Pillars/Pillars.js === */

import React from 'react';
import './Pillars.css';

function Pillars() {
  return (
    // 'pillars-container' terá um fundo cinza-claro para diferenciar
    <section className="pillars-container">
      <div className="pillars-content">
        
        <h2 className="pillars-section-title">Nosso Ecossistema</h2>
        <p className="pillars-section-subtitle">
          A Aetheries atua em quatro pilares estratégicos para garantir 
          uma IA ética e responsável em todas as frentes.
        </p>

        {/* Grid para os 4 cards */}
        <div className="pillars-grid">
          
          {/* Card 1: AetherCore */}
          <div className="pillar-card">
            <h3 className="pillar-title">🧠 AetherCore</h3>
            <p className="pillar-description">
              O núcleo técnico de análise e validação. Criamos validadores 
              automáticos (AetherCheck) e geramos relatórios de conformidade.
            </p>
          </div>

          {/* Card 2: AetherLabs */}
          <div className="pillar-card">
            <h3 className="pillar-title">🔬 AetherLabs</h3>
            <p className="pillar-description">
              Centro de pesquisa e desenvolvimento. Criamos datasets éticos 
              e exploramos o futuro da IA responsável (fairness, interpretabilidade).
            </p>
          </div>

          {/* Card 3: AetherGov */}
          <div className="pillar-card">
            <h3 className="pillar-title">🏛️ AetherGov</h3>
            <p className="pillar-description">
              Ponte entre a tecnologia e a regulação. Contribuímos com 
              políticas públicas e modelos de governança algorítmica.
            </p>
          </div>

          {/* Card 4: AetherImpact */}
          <div className="pillar-card">
            <h3 className="pillar-title">🤝 AetherImpact</h3>
            <p className="pillar-description">
              Educação e transformação social. Oferecemos programas de 
              formação e certificações em ética digital para capacitar a sociedade.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Pillars;